/**
 * ReportEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { VisitEntity } from "../VisitEntity";
import { RegionEntity } from "../RegionEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { ReportGroupEntity } from "../ReportGroupEntity";
import { ReportEntity } from "../ReportEntity";
declare global {
    interface EntityTypeMap {
        Report: ReportEntity;
    }
}
export abstract class ReportGeneratedEntity extends BaseEntity {
    public abstract reportId: string;
    public abstract templateId: string | null;
    public abstract filename: string | null;
    public abstract date: Date | null;
    public abstract visitName: string | null;
    public abstract visitDate: Date | null;
    public abstract prefix: string | null;
    public abstract provider: string | null;
    public abstract permaLink: string | null;
    public abstract isShared: number | null;
    public abstract isSigned: number | null;
    public abstract mapsIncluded: number | null;
    public abstract reportTemplate: string | null;
    public abstract isDemo: number | null;
    public abstract temp: boolean;
    public abstract password: string | null;
    public abstract generationStatus: number | null;
    public abstract generationErrorCode: string | null;
    public abstract project: ProjectEntity;
    public abstract creator: ProjectUserEntity | null;
    public abstract visit: VisitEntity | null;
    public abstract region: RegionEntity | null;
    public abstract bugGroup: BugGroupEntity | null;
    public abstract reportGroup: ReportGroupEntity | null;
}
